import React, { useState, useContext } from "react";
import {
  Typography,
  TextField,
  Container,
  Button,
  Paper,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { isEmpty } from "lodash";
import { Stack } from "@mui/system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { DataContext } from "../../../context/DataContext";
import { simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { changeUserPasswordAsync } from "../../../api/Users";

const ChangeUserPassword = ({ id, setShowModal }) => {
  const token = getToken();
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);

  const [showPassword, setShowPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const validate = () => {
    let isValid = true;
    if (isEmpty(newPassword)) {
      simpleMessage("Debe ingresar una contraseña", "error");
      return (isValid = false);
    }
    if (newPassword.length < 6) {
      simpleMessage(
        "Debe ingresar una contraseña mayor de 6 caracteres",
        "error"
      );
      return (isValid = false);
    }
    if (isEmpty(confirmPassword)) {
      simpleMessage("Debe confirmar su contraseña", "error");
      return (isValid = false);
    }
    if (newPassword !== confirmPassword) {
      simpleMessage("La confirmacion de contraseña no coincide", "error");
      return (isValid = false);
    }
    return isValid;
  };

  const saveChanges = async () => {
    if (!validate()) {
      return;
    }

    const datos = {
      id,
      newPassword,
      confirmPassword,
    };

    setIsLoading(true);
    const result = await changeUserPasswordAsync(token, datos);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }

    setIsLoading(false);
    simpleMessage("Contraseña actualizada...!", "success");
    setNewPassword("");
    setConfirmPassword("");
    setShowModal(false);
  };

  return (
    <div>
      <Container style={{ width: 450 }}>
        <Paper
          style={{
            padding: 10,
          }}
        >
          <Typography
            variant="h6"
            color={"#2979ff"}
            style={{ textAlign: "center", marginBottom: 20 }}
          >
            Cambiar Contraseña
          </Typography>

          <Stack spacing={2}>
            <TextField
              required
              fullWidth
              onChange={(e) => setNewPassword(e.target.value)}
              value={newPassword}
              label={"Nueva contraseña"}
              type={showPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label="toggle password visivility"
                    >
                      {showPassword ? (
                        <FontAwesomeIcon
                          icon={faEye}
                          style={{ color: "#105155" }}
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={faEyeSlash}
                          style={{ color: "#105155" }}
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              required
              fullWidth
              onChange={(e) => setConfirmPassword(e.target.value)}
              value={confirmPassword}
              label={"Confirmar contraseña"}
              type={showPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label="toggle password visivility"
                    >
                      {showPassword ? (
                        <FontAwesomeIcon
                          icon={faEye}
                          style={{ color: "#105155" }}
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={faEyeSlash}
                          style={{ color: "#105155" }}
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              variant="outlined"
              startIcon={
                <FontAwesomeIcon icon={faSave} style={{ marginRight: 20 }} />
              }
              fullWidth
              onClick={() => saveChanges()}
              style={{
                color: "#00a152",
                borderColor: "#00a152",
              }}
              size="large"
            >
              Guardar Contraseña
            </Button>
          </Stack>
        </Paper>
      </Container>
    </div>
  );
};

export default ChangeUserPassword;
